import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { LoggerService } from '@core/services/infra/logger.service';

interface PublicConfig {
  googleMapsApiKey: string;
  stripePublishableKey: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly CONTEXT = 'AppConfigService';
  private readonly functions = inject(Functions);
  private readonly logger = inject(LoggerService);

  private configPromise: Promise<PublicConfig> | null = null;

  private load(): Promise<PublicConfig> {
    if (!this.configPromise) {
      this.configPromise = (async () => {
        try {
          const callable = httpsCallable<unknown, PublicConfig>(this.functions, 'getPublicConfig');
          const result = await callable({});
          return result.data;
        } catch (err) {
          this.configPromise = null;
          this.logger.error('Failed to load runtime config from Secret Manager', this.CONTEXT, err);
          throw err;
        }
      })();
    }
    return this.configPromise;
  }

  async getMapsApiKey(): Promise<string> {
    return (await this.load()).googleMapsApiKey;
  }

  async getStripePublishableKey(): Promise<string> {
    return (await this.load()).stripePublishableKey;
  }

  invalidate(): void {
    this.configPromise = null;
  }
}
